module.exports = __webpack_public_path__ + "img/imgUser.4138e628.svg";